import React, { Component } from "react" 
import './styles.scss'
import styled from 'styled-components'
//import PropTypes from 'prop-types'
import Digit from './Digit'
export default class Timer extends Component {
  constructor(props) {
    super(props) 

    const localStorageVlaue = "timer2"
    const intervalValue = 150

    try {

      console.log("intervalValue--> ",intervalValue)

      this.state = JSON.parse(localStorage.getItem(localStorageVlaue)) 
    } catch (error) {
      console.log("nil")
    }

    if (!this.state) {
      this.state = this.saveChanges({
        running: false,
        value: 0
      }) 
    }
  }

  componentWillMount() {
    console.log("this.state.running", this.state.running)
    if (this.state.running) {
      this.timer = setInterval(
        () => {this.forceUpdate()},
        150 | 1000
      ) 
    }else{

      const now = Date.now() 

    this.setState(({ running, value }) => {
      if (running) return null 

      this.timer = setInterval(
        () => {this.forceUpdate()},
        150 | 1000
      ) 

      return this.saveChanges({
        running: true,
        value: value - now
      }) 
    }) 

    }
  }

  componentWillUnmount() {
    if (this.state.running) {
      clearInterval(this.timer) 
    }
  }

  saveChanges(state) {
    console.log("saveChanges", "timer2", state) 
      localStorage.setItem("timer2", JSON.stringify(state)) 
    return state 
  }

  start = () => {
    const now = Date.now() 

    this.setState(({ running, value }) => {
      if (running) return null 

      this.timer = setInterval(
        () => this.forceUpdate(),
        150 | 0
      ) 

      return this.saveChanges({
        running: true,
        value: value - now
      }) 
    }) 
  } 


  stop = () => {
    const now = Date.now() 

    this.setState(({ running, value }) => {
      if (!running) return null 

      clearInterval(this.timer) 
      return this.saveChanges({
        running: false,
        value: value + now
      }) 
    }) 
  } 

  reset = () => {
    //const now = Date.now() 

    this.setState(() => {
      return this.saveChanges({
        running: false,
        value: 0
      }) 

    //   //just reset the timer to 0, don' stop it
      //return this.saveChanges({
      //  running,
      //  value: running? -now: 0
      //}) 
    }) 
  } 

  render() {
    const {
      // start,
      // stop,
      // reset,
      state: { running, value }
    } = this 

    const timestamp = running ? Date.now() + value : value 
    const hours = Math.floor(timestamp / 3600000) 
    const minutes = Math.floor(timestamp / 60000) % 60 
    const seconds = Math.floor(timestamp / 1000) % 60 
    
     

      const TimerContainer = styled.div`
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0px;
      align-items: center;
    `
    
    const SepartorContainer = styled.span`
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: flex-end;
      margin: 0px;
    `
    
    const Separtor = styled.span`
      display: inline-block;
      width: 5px;
      height: 5px;
      background-color: #404549;
      border-radius: 6px;
      margin: 4px 0px;
    `
    return (<>
      <TimerContainer>
      <Digit value={hours} title="HOURS" addSeparator />
      <SepartorContainer><Separtor /><Separtor /></SepartorContainer>
      <Digit value={minutes} title="MINUTES" addSeparator />
      <SepartorContainer><Separtor /><Separtor /></SepartorContainer>
      <Digit value={seconds} title="SECONDS" />
    </TimerContainer>
    
    </>) 

    // return (
    //   <div className="container d-none d-sm-inline-block xl-6 ">
        // <div className="timer-container">
        //   <div className="current-timer">
        //     {_(h) + ":" + _(m) + ":" + _(s)  }
        //   </div>  </div>
    //       <div className="timer-controls">
    //         {/* <button className="btn btn-success" onClick={start}>
    //           Start Timer
    //         </button>

    //         <button className="btn btn-alert" onClick={stop}>
    //           Stop Timer
    //         </button>

    //         <button className="btn btn-danger" onClick={reset}>
    //           Reset!
    //         </button>  */}
        
    //     </div>
    //   </div>
    // ) 

  }
}
